/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Persisted, account-level Parental Control state delivered by FE as
 * `parentalSettings-state`. Temp Off is not a persisted state — see
 * `IParentalRuleEngine.isTempOffActive`.
 */
enum ParentalControlState {
  /** Rating limits and PIN challenges are enforced. */
  ON = "ON",

  /** No rating enforcement. Hide Adult Content still applies independently. */
  OFF = "OFF"
}

export { ParentalControlState };
